import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");
  const [orderCode, setOrderCode] = useState(null);
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let active = true;
    const poll = async () => {
      if (!active) return;
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setOrderCode(data.order_code);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (data.payment_status === "expired" || data.status === "failed") { setState("error"); return; }
      } catch (e) { /* keep polling */ }
      if (attempts.current >= 8) { setState("timeout"); return; }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { active = false; };
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream px-6">
      <div className="bg-white rounded-3xl brand-shadow p-10 max-w-md w-full text-center">
        {state === "checking" && (<><Loader2 className="w-12 h-12 text-orange animate-spin mx-auto" /><h1 className="mt-5 text-xl font-bold text-navy">Verifica pagamento...</h1></>)}
        {state === "paid" && (<>
          <div className="w-16 h-16 rounded-full bg-successbg flex items-center justify-center mx-auto"><CheckCircle2 className="w-8 h-8 text-successtext" /></div>
          <h1 className="mt-5 text-xl font-bold text-navy">Pagamento riuscito!</h1>
          <p className="mt-2 text-navy/60">Il tuo ordine è stato confermato. Buona colazione!</p>
          <Button onClick={() => navigate(`/ordine/${orderCode}`)} className="mt-6 rounded-full bg-navy text-white h-11 px-8" data-testid="view-order-btn">Vedi il tuo ordine</Button>
        </>)}
        {(state === "error" || state === "timeout") && (<>
          <div className="w-16 h-16 rounded-full bg-errorbg flex items-center justify-center mx-auto"><XCircle className="w-8 h-8 text-errortext" /></div>
          <h1 className="mt-5 text-xl font-bold text-navy">{state === "timeout" ? "Verifica in corso" : "Pagamento non completato"}</h1>
          <p className="mt-2 text-navy/60">{state === "timeout" ? "Il pagamento potrebbe richiedere qualche istante. Controlla lo stato dell'ordine." : "Riprova o scegli il pagamento in struttura."}</p>
          {orderCode && <Button onClick={() => navigate(`/ordine/${orderCode}`)} className="mt-6 rounded-full bg-navy text-white h-11 px-8">Vedi ordine</Button>}
        </>)}
      </div>
    </div>
  );
}
